import React, { useEffect, useState } from "react";
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import useAuth from "hooks/useAuth";
import "react-phone-number-input/style.css";
import DatePicker from "components/Datepicker/Datepicker";
import MaskReal from "services/formateRS";

import api from "assets/services/api";

function ModalAddDebits(props) {
  const [br, setBR] = useState(false);

  const [description, setDescription] = useState();
  const [value, setValue] = useState();
  const [analyticals, setAnalyticals] = useState([]);
  const [id_analyticalin, setId_analyticalin] = useState();
  const [id_analyticalfor, setId_analyticalfor] = useState();
  const [date_of_debit, setDate_of_debit] = useState();
  const { storageId } = useAuth();
  const [controlSnack, setControlSnack] = useState(false);

  const showNotification = (place) => {
    switch (place) {
      case "br":
        if (!br) {
          setBR(true);
          setTimeout(function () {
            setBR(false);
            setControlSnack(false);
          }, 6000);
        }
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (controlSnack) showNotification("br");
  }, [controlSnack]);

  useEffect(() => {
    getAllAnalyticals();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function handleAddDebit(e) {
    e.preventDefault();
    if (date_of_debit) {
      const response = await api.post("/debit", {
        description: description,
        value: value,
        id_admin: storageId,
        id_analyticalin: id_analyticalin,
        id_analyticalfor: id_analyticalfor,
        date_of_debit: date_of_debit,
      });
      if (response.data.error) {
        return alert(response.data.error);
      }
      props.getAllDebit();
      setControlSnack(true)
    } else {
      alert('A data do lançamento esta vazia')
    }
  }

  async function getAllAnalyticals() {
    const response = await api.get("/Analytical/all?id_admin=" + storageId);


    if (response.data.lenght !== 0) {
      setAnalyticals(response.data);
      setId_analyticalfor(response.data[0].id)

      if (response.data[1]) {
        setId_analyticalin(response.data[1].id)
      }
    }
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Adicionar lançamento de débito
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleAddDebit}>
        <Modal.Body>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridDescription">
              <Form.Label>Descrição</Form.Label>
              <Form.Control
                onChange={(event) => setDescription(event.target.value)}
                type="text"
                placeholder="Descrição do lançamento"
                required
              />
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridValue">
              <Form.Label>Valor</Form.Label>
              <MaskReal value={value} onChange={value => setValue(value.replace(',', '.'))} />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridDate">
              <Form.Label>Data do lançamento</Form.Label>
              <div>
                <DatePicker
                  selected={date_of_debit}
                  onChange={(date) => setDate_of_debit(date.withoutTime())}
                  dateFormat="dd/MM/yyyy"
                  placeholderText="Digite ou clique aqui"
                  disabledKeyboardNavigation
                  required
                />
              </div>
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridAlternativeRoute">
              <Form.Label>Débito</Form.Label>
              <Form.Control
                onChange={(event) => setId_analyticalin(event.target.value)}
                value={id_analyticalin}
                as="select"
                defaultValue="Choose..."
                required
              >
                {analyticals.map((analytical) => (
                  <option key={String(analytical.id)} value={analytical.id}>
                    {analytical.code} - {analytical.description}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group as={Col} controlId="formGridAlternativeRoute">
              <Form.Label>Crédito</Form.Label>
              <Form.Control
                onChange={(event) => setId_analyticalfor(event.target.value)}
                value={id_analyticalfor}
                as="select"
                defaultValue="Choose..."
                required
              >
                {analyticals.map((analytical) => (
                  <option key={String(analytical.id)} value={analytical.id}>
                    {analytical.code} - {analytical.description}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Form.Row>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-center">
            <Button color="success" type="submit">
              Adicionar lançamento de débito
            </Button>
            <Snackbar
              place="br"
              color="success"
              icon={AddAlert}
              message="Lançamento de débito adicionado com sucesso"
              open={br}
              closeNotification={() => setBR(false)}
              close
            />
          </div>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default ModalAddDebits;
